import {ActionContext} from "vuex";
import {ThemeConfig} from "@/model/config/ThemeConfig";
import { Fetch } from 'water-rest/src/fetch/Fetch';

export const ThemeModule = {
    namespaced: true,
    state: (): IThemeState => ({
        themeConfig: null,
        isThemeConfigLoading: false
    }),
    mutations: {
        setThemeConfig(state: IThemeState, themeConfig: ThemeConfig) {
            state.themeConfig = themeConfig;
        },
        setDefaultThemeConfig(state: IThemeState) {
            state.themeConfig = {
                themeName: null,
                copyrightText: null,
                copyrightYearFrom: null,
                loginFormTitle: null,
                documentTitle: null,
                hideLoginPageLogo: null,
                showLoginPageTopLogo: null,
                showLoginPageSideLogo: null,
                rawLogo: null
            };
        },
        setIsThemeConfigLoading(state: IThemeState, isThemeConfigLoading: boolean) {
            state.isThemeConfigLoading = isThemeConfigLoading;
        }
    },
    actions: {
        requestConfig(context: ActionContext<IThemeState, any>) {
            return new Promise<ThemeConfig>(resolve => {
                context.commit('setIsThemeConfigLoading', true);
                fetch(`${Fetch.buildAuthModuleUrl()}/config/theme`)
                    .then( async response => {
                        const contentType = response.headers.get('content-type');
                        const isJson = !!contentType && contentType.includes('application/json');
                        if ( response.ok && isJson ) {
                            const config: ThemeConfig = await response.json();
                            context.commit('setThemeConfig', config);
                        }
                        else {
                            context.commit('setDefaultThemeConfig');
                        }
                    } )
                    .catch( () => {
                        context.commit('setDefaultThemeConfig');
                    } )
                    .finally( () => {
                        context.commit('setIsThemeConfigLoading', false);
                        resolve(context.getters.themeConfig)
                    } );
            });
        }
    },
    getters: {
        themeConfig(state: IThemeState): ThemeConfig | null {
            return state.themeConfig;
        },
        isThemeConfigLoading(state: IThemeState): boolean {
            return state.isThemeConfigLoading;
        },
    }
};


interface IThemeState {
    themeConfig: ThemeConfig | null;
    isThemeConfigLoading: boolean;
}
